import styled from "styled-components";

export const AuthForm = styled.div`

`